import StaticCard from '@/components/UI/StaticCard'
import { cn } from '@/lib/utils'
import React from 'react'
import { Skeleton, Stack } from '@mui/material'

const MetricOverview: React.FC<{
  data: Array<{
    title: string
    value: number
    type?: 'percent' | 'default'
    helperText?: string
    showChartIcon?: boolean
  }>
  isLoading?: boolean
}> = ({ data, isLoading = false }) => {
  return (
    <div
      className={cn(
        'tw-grid tw-grid-cols-2 tw-gap-2',
        data.length % 3 === 0 ? 'md:tw-grid-cols-3' : 'md:tw-grid-cols-4',
      )}
    >
      {isLoading
        ? Array.from({ length: data.length || 4 }).map((_, index) => (
            <div
              key={`skeleton-${index}`}
              className="tw-border tw-rounded-2xl tw-shadow-md tw-p-6 tw-flex tw-flex-col tw-gap-2 tw-justify-between"
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Skeleton
                  variant="text"
                  width="60%"
                  height={20}
                  sx={{ borderRadius: '4px' }}
                />
                <Skeleton
                  variant="circular"
                  width={24}
                  height={24}
                  sx={{ opacity: 0.3 }}
                />
              </Stack>

              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Skeleton
                  variant="text"
                  width="40%"
                  height={32}
                  sx={{ borderRadius: '4px' }}
                />
                <Skeleton
                  variant="rectangular"
                  width={24}
                  height={24}
                  sx={{ borderRadius: '4px', opacity: 0.3 }}
                />
              </Stack>
            </div>
          ))
        : data.map(item => (
            <StaticCard
              key={item.title}
              title={item.title}
              value={item.value}
              type={item.type === 'percent' ? 'percent' : 'default'}
              helperText={item.helperText}
              showChartIcon={item.showChartIcon}
            />
          ))}
    </div>
  )
}

export default MetricOverview
